import { Component } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { GoogleTagManagerService } from "angular-google-tag-manager";
import { AuthenticationService } from './authentication.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastService } from "./toasts.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  //properties
  title = "RegScale.com";
  user: any;


  //inject services
  constructor(private router: Router, private auth: AuthenticationService, private gtmService: GoogleTagManagerService, private _snackBar: MatSnackBar, private tst: ToastService) {
    //setup a listener for login status
    this.auth.loginStatusChange.subscribe(data => {
      this.user = data;
    });

    //listen for toasts
    this.tst.subscribe(value => {
      this._snackBar.open(value["textOrTpl"].toString(), 'Dismiss', { duration: 5000, panelClass: 'snackIndex' });
  });
  }

  //initialize the component
  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    //tag each page in Google Tag Manager
    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
          const gtmTag = {
              event: 'page',
              pageName: item.url
          };

          this.gtmService.pushTag(gtmTag);
      }
  });
  }

  
}
